import http from '../../baseUrl/HttpCommon';
import authHeader from '../authHeader/AuthHeader';

const getLoadUsers = (CompanyId, roleId) => {
  return http.get(`/Administration/LoadUsers?CompanyId=${CompanyId}&RoleId=${roleId}`, {
    headers: authHeader(),
  });
};
const getUserManagement = (userId) => {
  return http.get(`/Administration/GetEditUserManagement?Userid=${userId}`, {
    headers: authHeader(),
  });
};

// const getAuditTrails = (CompanyId, roleId) => {
//   return http.get(`/Administration/GetUserAuditTrail?CompanyId=${CompanyId}&RoleId=${roleId}`, {
//     headers: authHeader(),
//   });
// };

// const getUserAuditTrail = (params) => {
//   return http.get('/SelfUserManagement/AllDetailsAuditLog', {
//     headers: authHeader(),
//     params, // Axios will build the query string automatically
//   });
// };

const getUserAuditTrail = (params) => {

  const queryString = new URLSearchParams(params).toString();
  return http.get(`/SelfUserManagement/AllDetailsAuditLogPgn?${queryString}`, null, {
    headers: authHeader(),
  });
};

const getLoggedHistory = (CompanyId, isSelfEmployed, roleId, pageNumber = 1, pageSize = 10) => {
  return http.get(
    `/Administration/LoggedInHistory?companyId=${CompanyId}${
      isSelfEmployed ? `&isSelfEmployed=${isSelfEmployed}` : ''
    }&RoleId=${roleId}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
    {
      headers: authHeader(),
    },
  );
};

const saveAndUpdateUser = (data) => {
  return http.post(`/Administration/SaveUser/UpdateUser`, data, {
    headers: authHeader(),
  });
};

const resetPassword = (data) => {
  return http.post(`/Administration/ResetPassword`, data, {
    headers: authHeader(),
  });
};

const getAllCompanyData = (isNW) => {
  return http.get(`/Auth/GetAllCompanyData${isNW ? '?nw=true' : ''}`, {
    headers: authHeader(),
  });
};

// const getAllCompany = (isNW, pageNumber, pageSize) => {
//   const params = new URLSearchParams();

//   if (isNW) params.append('nw', 'true');
//   if (pageNumber !== undefined) params.append('pageNumber', pageNumber);
//   if (pageSize !== undefined) params.append('pageSize', pageSize);

//   const queryString = params.toString(); // "nw=true&pageNumber=1&pageSize=10"

//   return http.get(`/Auth/GetAllCompany${queryString ? `?${queryString}` : ''}`, {
//     headers: authHeader(),
//   });
// };

const getAllCompany = (pageNumber, pageSize) => {
  debugger;
  return http.get(`/Auth/GetAllCompany?pageNumber=${pageNumber}&pageSize=${pageSize}`, {
    headers: authHeader(),
  });
};

const getAllSelfEmployerData = () => {
  return http.get(`/Auth/GetAllEmployersSelfData?userid=0&roleid=1`, {
    headers: authHeader(),
  });
};

const getAllSelfEmployer = (pageNumber, pageSize) => {
  return http.get(
    `/Auth/GetAllEmployersSelf?userid=0&roleid=1&pageNumber=${pageNumber}&pageSize=${pageSize}`,
    {
      headers: authHeader(),
    },
  );
};

const getSelfPersonal = (userId) => {
  return http.get(`/Administration/GetUserProfile?userId=${userId}`, {
    headers: authHeader(),
  });
};

const getSelfEmployeeReport = ({ companyId }) => {
  return http.get(`/SelfEmpContribution/MainGridSelfEmpContribution?CompanyId=${companyId}`, {
    headers: authHeader(),
  });
};

const resetUserData = (userId) => {
  return http.get(`/Administration/ResetSendMail?UserId=${userId}`, {
    headers: authHeader(),
  });
};

const getAllEmployeeAndWoking = (CompanyId, roleId =1) => {
  return http.get(`/Administration/LoadUsers?CompanyId=${CompanyId}&RoleId=${roleId}`, {
    headers: authHeader(),
  });
};

const UserManagementServices = {
  getLoadUsers,
  saveAndUpdateUser,
  getSelfPersonal,
  getAllSelfEmployer,
  getSelfEmployeeReport,
  getUserAuditTrail,
  getUserManagement,
  getLoggedHistory,
  getAllCompany,
  resetPassword,
  resetUserData,
  getAllCompanyData,
  getAllSelfEmployerData,
  getAllEmployeeAndWoking,
};

export default UserManagementServices;
